(function (angular) {
  "use strict";

  var m = angular.module("app");

  m.directive("pcmFormContainer", ["_", function (_) {
    return {
      restrict: "AE",
      scope: {},
      require: ["pcmFormContainer"],
      controller: function ($scope) {
        var forms = [];
        var controller = this;

        this.addForm = function (newForm) {
          forms.push(newForm);
        };

        this.submitForms = function (event) {
          var i = 0,
            allFormsValid = true;

          // first, check if all the forms which should be submitted are valid
          for (i = 0; i < forms.length; i++) {
            if (forms[i].controller.shouldSubmit(event) === true) {
              forms[i].controller.setSubmitted(true);

              if (forms[i].controller.$valid === false) {
                allFormsValid = false;
              }
            }
          }

          if (allFormsValid === true) {
            // all the forms which should be submitted are valid, submit all the forms which should be submitted
            var sortedForms = _.sortBy(forms, "pcmOrder");

            for (i = 0; i < sortedForms.length; i++) {
              if (sortedForms[i].controller.shouldSubmit(event) === true) {
                sortedForms[i].element.submit();
              }
            }
          }
        };
      }
    };
  }]).directive("pcmForm", function () {
    return {
      require: ["^pcmFormContainer", "form"],
      restrict: "A",
      scope: {
        pcmOrder: "=" // allow a specific order be used for submitting forms
      },
      link: function (scope, element, attrs, controllers) {
        var formController = controllers[0];
        formController.addForm({
          controller: controllers[1],
          element: element,
          pcmOrder: scope.pcmOrder
        });
      }
    };
  }).directive("pcmContainerSubmit", function () {
    return {
      require: ["^pcmFormContainer"],
      scope: {},
      restrict: "AE",
      link: function (scope, element, attrs, controllers) {
        var formController = controllers[0];

        element.on("click", function (event) {
          formController.submitForms(event);
        });
      }
    };
  });

})(window.angular);



// WEBPACK FOOTER //
// ./app/components/formContainer.directive.js